{
  "bot_control_center": {
    "breadcrumb": "Company / Automated service",
    "title": "Automated Service Control Centre",
    "loading": "Loading the Control Centre...",
    "load_error": "The Control Centre could not be loaded.",
    "retry": "Try again",
    "yes": "Yes",
    "no": "No",
    "available": "Available",
    "unavailable": "Unavailable",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "assistive_ai": "Assistive AI",
    "explain": "Explain",
    "configuration": {
      "breadcrumb": "Company / Service bot",
      "title": "Service Bot",
      "subtitle": "Configure the flow, review each stage and monitor automated service decisions.",
      "apply_default": "Apply default flow",
      "save": "Save configuration",
      "loading": "Loading bot configuration...",
      "not_configured": "Not configured",
      "team": "Company team",
      "user_fallback": "User {id}",
      "main_settings": "Main settings",
      "bot_active": "Bot active",
      "bot_inactive": "Bot inactive",
      "ok": "OK",
      "pending": "Pending",
      "configured": "Configured",
      "open": "Open",
      "close": "Close",
      "advanced_mode": "Advanced mode",
      "action": "Action",
      "priority": "Priority",
      "keywords": "Keywords",
      "summary": {
        "answers_when": "When the bot replies",
        "handoff_target": "Who takes over when a person is needed",
        "off_hours": "What happens outside business hours",
        "default_flow": "Default flow",
        "ready": "Ready to use",
        "needs_configuration": "Configuration still required"
      },
      "fields": {
        "enable_bot": "Enable service bot",
        "allow_handoff": "Allow transfer to an agent",
        "assignment_mode": "How to distribute new leads",
        "default_user": "Default user",
        "answer_policy": "When the bot may reply",
        "off_hours_policy": "Outside-hours policy",
        "session_timeout": "Session timeout (min)",
        "max_retries": "Attempts before transfer"
      },
      "assignment_modes": { "default": "Default user", "queue": "User queue", "bot_system": "Bot system" },
      "answer_policies": {
        "always": "Always",
        "business_hours_only": "Business hours only",
        "off_hours_only": "Outside business hours only",
        "never": "Never"
      },
      "off_hours_policies": {
        "queue": "Keep in queue",
        "keep_assigned": "Keep current assignee",
        "bot_only": "Leave with bot only"
      },
      "weekdays": { "0": "Sun", "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat" },
      "dependencies": {
        "kicker": "Dependencies",
        "title": "What affects bot behaviour",
        "business_hours": "Business hours",
        "templates": "Templates",
        "integrations": "Integrations",
        "no_business_hours": "Business hours not configured",
        "more_hours": "+{count} schedules",
        "template_count": "{count} template(s) available",
        "no_templates": "No templates registered",
        "no_integrations": "No active integrations"
      },
      "alerts": {
        "bot_disabled": {
          "title": "Bot disabled",
          "description": "The bot is configured but will not reply until enabled."
        },
        "business_hours_missing": {
          "title": "Business hours not configured",
          "description": "Configure business hours so time-based rules work correctly."
        },
        "guided_flow_incomplete": {
          "title": "Guided flow incomplete",
          "description": "The default flow has not been fully applied to this company."
        },
        "bot_user_missing": {
          "title": "Bot user not provisioned",
          "description": "The virtual user will be created automatically when the flow needs it."
        },
        "templates_missing": {
          "title": "No templates registered",
          "description": "Shortcuts remain available, but no template was found for this company."
        }
      },
      "flow": {
        "kicker": "Service flow",
        "title": "Each stage leads to a bot action",
        "extra_rules": "{count} extra rule(s)",
        "when": "When this happens",
        "action": "What the bot does",
        "next": "Next step",
        "main_message": "Main message",
        "preview": "User preview",
        "no_message": "No message configured.",
        "retry_message": "Retry message",
        "retry_preview": "Retry preview",
        "trigger_keywords": "Words that trigger this stage",
        "trigger_keywords_example": "E.g. hi, hello, good morning",
        "handoff_keywords": "Words that request a person",
        "handoff_keywords_example": "E.g. person, agent, salesperson",
        "no_technical_rule": "No technical rule is associated with this stage."
      },
      "stages": {
        "welcome": {
          "title": "Initial entry",
          "when": "When the customer starts the conversation.",
          "action": "Welcomes the customer and starts triage.",
          "next": "Capture name"
        },
        "capture_name": {
          "title": "Capture name",
          "when": "When the bot asks for the name and interprets the response.",
          "action": "Identifies the name, confirms registration and retries if needed.",
          "next": "Understand interest"
        },
        "interest_prompt": {
          "title": "Understand interest",
          "when": "When the name is recorded and the bot needs to understand the interest.",
          "action": "Guides the conversation towards the service topic.",
          "next": "Human request or service continuity"
        },
        "handoff_request": {
          "title": "Human request",
          "when": "When the customer asks for a human agent.",
          "action": "Transfers to an agent according to company policy.",
          "next": "Human agent"
        },
        "offhours_default": {
          "title": "Outside business hours",
          "when": "When the conversation happens outside business hours.",
          "action": "Explains unavailability and keeps service in outside-hours mode.",
          "next": "Return in the next working period or restricted continuity"
        }
      },
      "states": {
        "inicio": "Start",
        "captura_nome": "Name capture",
        "captura_interesse": "Interest capture",
        "agendar": "Schedule",
        "fora_do_horario": "Outside business hours",
        "encerrado": "Closed",
        "humano": "Human service"
      },
      "monitoring": {
        "kicker": "Monitoring",
        "title": "Why did the bot do this?",
        "sessions": "Sessions",
        "logs": "Logs",
        "recent_sessions": "Recent sessions",
        "recent_logs": "Recent logs",
        "contact": "Contact",
        "lead": "Lead",
        "stage": "Stage",
        "last_activity": "Last activity",
        "summary": "Summary",
        "no_lead": "No lead",
        "view_timeline": "View timeline",
        "no_sessions": "No recent sessions for this company.",
        "time": "Time",
        "inbound_message": "Received message",
        "matched_rule": "Applied rule",
        "actions": "Actions",
        "final_stage": "Final stage",
        "no_rule": "No identified rule",
        "not_identified": "Not identified",
        "no_actions": "No actions recorded",
        "explain_response": "Explain response",
        "no_logs": "No recent logs for this company.",
        "no_recent_log": "No recent log",
        "session_timeline": "Bot session",
        "log_timeline": "Bot log"
      },
      "timeline": {
        "current_state": "Current stage",
        "last_activity": "Last activity",
        "last_inbound": "Last received message",
        "customer_sent": "Customer sent",
        "state_before": "Bot was at stage",
        "rule_applied": "Applied rule",
        "action_executed": "Executed action",
        "state_after": "Final stage"
      },
      "advanced": {
        "kicker": "Advanced",
        "title": "Technical bot rules",
        "rule_count": "{count} rule(s)",
        "description": "Description",
        "type": "Type",
        "guided": "Guided",
        "extra": "Extra",
        "system_key": "System key",
        "no_rules": "No technical rules registered.",
        "technical_rule": "Technical rule"
      },
      "actions": {
        "reply": "Reply",
        "set_context": "Update context",
        "create_lead": "Create or update lead",
        "schedule": "Schedule",
        "handoff": "Transfer to an agent",
        "ask_name": "Ask for name again",
        "capture_name": "Capture name",
        "offhours_reply": "Reply outside business hours"
      },
      "preview": {
        "company": "Example Company",
        "customer": "Maria Customer",
        "agent": "Carlos Agent",
        "message": "Hello, I need help with an SUV."
      },
      "notifications": {
        "load_error": "The bot configuration could not be loaded.",
        "saved": "Bot configuration saved successfully.",
        "save_error": "The bot configuration could not be saved.",
        "bootstrap_success": "Default flow applied successfully.",
        "bootstrap_error": "The default flow could not be applied."
      }
    },
    "tabs": {
      "overview": "Overview",
      "config": "Configuration",
      "operations": "Conversations and decisions",
      "diagnostics": "Diagnostics"
    },
    "engines": { "none": "None", "rules": "Rules flow", "orchestrator": "Smart flow" },
    "outcomes": {
      "replied": "Replied",
      "skipped": "Skipped",
      "handoff": "Transferred to an agent",
      "error": "Error",
      "no_reply": "No reply"
    },
    "statuses": { "operating": "Operating", "paused": "Paused", "partial": "Partial", "error": "Error" },
    "llm_statuses": {
      "active": "Active",
      "canary": "Pilot",
      "unavailable": "Unavailable",
      "not_enabled": "Not enabled"
    },
    "readiness": { "healthy": "Healthy", "degraded": "Degraded", "unavailable": "Unavailable", "unknown": "Unknown" },
    "status": {
      "automatic_service": "Automated service",
      "answers_now": "Answering now?",
      "in_business_hours": "Within business hours",
      "outside_business_hours": "Outside business hours",
      "main_flow": "Primary flow",
      "continuity_available": "Rules continuity available",
      "continuity_unavailable": "No continuity configured",
      "calls_today": "{calls} / {limit} calls today",
      "calculated_at": "Status calculated at {date}",
      "last_execution": "Last execution",
      "view_conversation": "View conversation"
    },
    "analytics": {
      "title": "Metrics",
      "loading": "Loading metrics...",
      "error": "Metrics could not be loaded.",
      "empty": "No data for this period.",
      "stale": "Metrics have not yet been consolidated for this period.",
      "partial": "Some days are still being consolidated; figures may change.",
      "today": "Today",
      "days_7": "7 days",
      "days_30": "30 days",
      "orchestrator": "Orchestrator",
      "success": "success",
      "continuity": "continuity",
      "errors": "Errors",
      "calls": "calls",
      "uses": "uses",
      "latency": "p50/p95 latency",
      "inbound_evaluated": "Inbound messages evaluated",
      "automated_replies": "Automated replies",
      "automation_rate": "Automation rate",
      "handoffs": "Transfers",
      "no_reply": "No reply"
    },
    "flow": {
      "title": "Message processing",
      "policy": "Policy and business hours",
      "policy_detail": "Checks whether automated service should reply now.",
      "smart_primary": "Smart flow (primary)",
      "rules_primary": "Rules flow (primary)",
      "smart_detail": "Understands the message and selects the best response.",
      "rules_detail": "Applies the company's configured rules.",
      "ai": "Assistive AI when needed",
      "ai_detail": "AI is only called when the rules cannot understand the message.",
      "tools": "Inventory and appointments",
      "tools_detail": "Checks inventory and schedules visits when requested.",
      "delivery": "Reply or agent",
      "delivery_detail": "Sends an automated reply or transfers to an agent.",
      "continuity": "If the primary flow fails, service continues through the rules flow."
    },
    "diagnostics": {
      "health": "Health and continuity",
      "readiness": "Smart flow availability",
      "observed_at": "observed at {date}",
      "no_heartbeat": "no recent signal",
      "rules_continuity": "Rules continuity",
      "recent_window": "Recent window (24h)",
      "recent_values": "{total} executions · {errors} errors · {fallbacks} continuities",
      "rollout_source": "Rollout source",
      "platform": "Platform governed",
      "legacy": "Legacy configuration",
      "ai_usage": "Assistive AI usage",
      "state": "Status",
      "classify": "Understanding (classify)",
      "rewrite": "Naturalisation (rewrite)",
      "daily_usage": "Daily usage",
      "calls": "{calls} / {limit} calls",
      "stage": "Stage"
    },
    "executions": {
      "title": "Conversations and decisions",
      "search": "Search by lead or phone",
      "outcome": "Outcome",
      "engine": "Engine",
      "ai_used": "AI used",
      "with_ai": "With AI",
      "without_ai": "Without AI",
      "protection": "Protection",
      "protection_applied": "Protection applied",
      "protection_not_applied": "No protection applied",
      "date_from": "Start date",
      "date_to": "End date",
      "loading": "Loading executions...",
      "error": "Executions could not be loaded.",
      "empty": "No executions match this period or filters.",
      "caption": "Automated service executions",
      "date_time": "Date/time",
      "lead": "Lead",
      "message": "Message",
      "action": "Action",
      "latency": "Latency",
      "details": "Details",
      "inventory": "Inventory",
      "schedule": "Schedule"
    },
    "drawer": {
      "title": "Explain this response",
      "loading": "Loading explanation...",
      "error": "This execution could not be loaded.",
      "empty_trace": "No steps were recorded for this execution.",
      "technical": "Technical details",
      "execution": "Execution",
      "communication": "Communication",
      "status": "Status",
      "attempts": "Attempts",
      "confidence": "Confidence",
      "ai_path": "AI path",
      "ai_calls": "AI calls",
      "latency": "Latency",
      "engine_value": "engine: {value}",
      "tool_value": "tool: {value}",
      "confidence_value": "confidence: {value}",
      "tools": { "inventory_search": "inventory search", "schedule_visit": "visit scheduling" },
      "confidence_bands": { "low": "low", "medium": "medium", "high": "high" },
      "results": "{count} result(s)",
      "steps": {
        "policy": "Policy and business hours",
        "engine": "Service engine",
        "intent": "Message understanding",
        "tool": "Inventory search",
        "schedule": "Appointment",
        "guardrail": "Response protection",
        "handoff": "Transfer to an agent",
        "delivery": "Response delivery"
      },
      "step_outcomes": {
        "allowed": "allowed",
        "blocked": "blocked",
        "skipped": "skipped",
        "selected": "selected",
        "fallback": "continuity activated",
        "requested": "requested",
        "sent": "sent",
        "no_reply": "no reply",
        "applied": "applied",
        "failed": "failed"
      }
    },
    "chat": {
      "automatic": "Automated",
      "automatic_label": "Sent by automated service",
      "guardrail": "Response protection applied",
      "explain_action": "Explain automated service",
      "no_auto_reply": "No automated reply",
      "no_execution": "This message has no explainable execution.",
      "imported_history": "Imported history"
    },
    "reasons": {
      "bot_disabled": "Automated service was disabled by an administrator.",
      "policy_never": "The company policy never allows automated replies.",
      "policy_blocked": "The current policy does not allow an automated reply now.",
      "outside_business_hours": "Outside business hours.",
      "inside_business_hours": "Within business hours.",
      "new_lead_off_hours_override": "A new lead was served outside business hours under the enabled exception.",
      "human_already_assigned": "The conversation is already assigned to a human agent.",
      "missing_contact_key": "The contact has no phone or identifier for a reply.",
      "orchestrator_disabled": "The smart flow is disabled for this company.",
      "orchestrator_timeout": "The smart flow timed out; the rules flow continued.",
      "orchestrator_unavailable": "The smart flow is unavailable; the rules flow continued.",
      "orchestrator_contract_error": "The smart flow returned an unexpected response; the rules flow continued.",
      "rules_fallback": "Service continued automatically through company rules.",
      "no_rule_matched": "No rule understood the message.",
      "rules_replied": "Replied through the rules flow.",
      "llm_not_needed": "Assistive AI was not needed.",
      "llm_disabled": "Assistive AI is disabled.",
      "llm_budget_exhausted": "Assistive AI reached its daily limit; the safe flow continued.",
      "llm_breaker_open": "Assistive AI is temporarily unavailable; the safe flow continued.",
      "llm_schema_invalid": "The AI response was rejected for safety; the safe flow continued.",
      "llm_low_confidence": "AI confidence was low; the deterministic flow continued.",
      "llm_success": "AI assisted message understanding.",
      "llm_fallback_success": "Assistive AI replied through continuity.",
      "guardrail_rewrite": "Protection was applied to the generated response.",
      "guardrail_commercial": "Commercial protection was applied to the response.",
      "inventory_ok": "Inventory returned available options.",
      "inventory_empty": "Inventory returned no current options.",
      "inventory_unavailable": "Inventory search is unavailable.",
      "schedule_created": "Visit scheduled.",
      "schedule_already_exists": "The visit was already scheduled.",
      "schedule_failed": "The visit could not be scheduled.",
      "handoff_requested": "Transfer to an agent requested.",
      "delivery_failed": "The response could not be sent.",
      "idempotency_hit": "A repeated message was ignored because it had already been processed.",
      "engine_error": "The message could not be processed."
    }
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects",
    "crm": "CRM",
    "agenda": "Schedule",
    "tarefas": "Tasks",
    "oportunidades": "Opportunities",
    "negociacao": "Negotiations",
    "propostas": "Proposals",
    "kanban": "Kanban",
    "dashboard_negociacao": "Dashboard",
    "template": "Templates",
    "bot_atendimento": "Customer Bot",
    "storage": "Storage",
    "painel": "Service Panel",
    "contato": "Contacts",
    "reports": "Reports",
    "reports_general": "General Reports",
    "reports_templates": "Templates",
    "reports_executions": "Executions",
    "businessHour": "Business Hours",
    "demos": "Demos",
    "leadContactDemo": "Leads and Contacts",
    "leadTest": "LeadTest",
    "company": "Company",
    "company_overview": "Company Details",
    "available": "Available",
    "sold": "Sold",
    "sales": "Sales",
    "sales_list": "List",
    "sales_new": "New sale",
    "user": "Users",
    "client": "Client"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore",
    "automations_processes": "Automations / Processing"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  }
}
